import PropTypes from 'prop-types';
import React from 'react';

import LegendItem, { ILegendItem } from '../../atoms/legend-item/legend-item';
import './legend.scss';
import { IClassNames, makeClassNames } from '../../../utils/styles';

export interface ILegend {
  title?: string;
  items: Array<ILegendItem>;
  dataType?: string;
}

const classNames = (): IClassNames =>
  makeClassNames({
    legend: 'legend',
    legendTitle: 'legend__title',
    legendItems: 'legend__items',
  });

const Legend: React.FC<ILegend> = ({ title, items, dataType }) => {
  const cn = classNames();

  return (
    <div className={cn.legend} data-type={dataType}>
      {title && <div className={cn.legendTitle}>{title}</div>}
      <ul className={cn.legendItems}>
        {items.map((item: ILegendItem, index: number) => (
          <LegendItem {...item} key={index}>
            {/* FIXME key={index}*/}
            {item.children}
          </LegendItem>
        ))}
      </ul>
    </div>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  Legend.propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({ ...LegendItem.propTypes!, children: PropTypes.node.isRequired }).isRequired
    ).isRequired,
    title: PropTypes.string,
  };
}

export default Legend;
